import { Upload } from "lucide-react";

export const DragDropOverlay = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-3 rounded-[3px] border-2 border-dashed border-zinc-300 px-10 py-8">
        <Upload className="h-10 w-10 text-zinc-400" />
        <p className="text-sm font-medium text-zinc-600">
          Drop files to attach
        </p>
        <p className="text-xs text-zinc-400">PDF files, up to 200MB each</p>
      </div>
    </div>
  );
};
